(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["estimated-delivery"] && !Shopify.designMode) return;
  try {
    (function () {
  var fromOffsetDays = 3;
  var toOffsetDays = 8;

  var fromDateEl = document.getElementById('ctm-estimated-delivery-from-date');
  var toDateEl = document.getElementById('ctm-estimated-delivery-to-date');
  var countdownEl = document.getElementById('ctm-estimated-delivery-countdown');

  if (!fromDateEl || !toDateEl || !countdownEl) return;

  function addDays(baseDate, days) {
    var date = new Date(baseDate.getTime());
    date.setDate(date.getDate() + days);
    return date;
  }

  function formatDate(date) {
    var options = { weekday: 'short', month: 'short', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  }

  var now = new Date();
  var fromDate = addDays(now, fromOffsetDays);
  var toDate = addDays(now, toOffsetDays);

  fromDateEl.textContent = formatDate(fromDate);
  toDateEl.textContent = formatDate(toDate);

  function updateCountdown() {
    var now = new Date();
    var endOfDay = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      23,
      59,
      59,
      999
    );

    var remaining = endOfDay.getTime() - now.getTime();

    if (remaining <= 0) {
      countdownEl.textContent = '0H 0M 0S';
      return;
    }

    var hours = Math.floor((remaining / (1000 * 60 * 60)) % 24);
    var minutes = Math.floor((remaining / (1000 * 60)) % 60);
    var seconds = Math.floor((remaining / 1000) % 60);

    var text = hours + 'H : ' + minutes + 'M : ' + seconds + 'S';
    
    // Simply update the text - no view transition needed
    countdownEl.textContent = text;

    window.setTimeout(updateCountdown, 1000);
  }

  updateCountdown();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery-ctm"] && !Shopify.designMode) return;
  try {
    class ProductGallerySlider extends HTMLElement {
  connectedCallback() {
    const gallery = this.closest('.pgs-gallery');
    const thumbsEl = gallery.querySelector('.pgs-thumbs');
    
    const thumbsSwiper = new Swiper(thumbsEl, {
      slidesPerView: 4,
      spaceBetween: 8,
      loop: false,
      // Navigation arrows configuration
      navigation: {
        nextEl: gallery.querySelector('.thumb-next'),
        prevEl: gallery.querySelector('.thumb-prev'),
      },
    });

    this.swiper = new Swiper(this, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      grabCursor: true,
      thumbs: { swiper: thumbsSwiper },
      // Optional: Agar main gallery mein bhi bullets chahiye
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
  }
}

if (!customElements.get('product-gallery-slider')) {
  customElements.define('product-gallery-slider', ProductGallerySlider);
}
  } catch(e) { console.error(e); }
})();

})();
